<template>
  <div class="header bg-primary">
    <div class="py-4 bg-primary justify-center items-center flex">
      <div>
        <img class="w-auto logo" src="../assets/logo.svg" alt="Logo FIVO">
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
<style lang="scss" scoped>
.logo {
  max-width: 300px;
  min-width: 200px;
}
.header {
  width: 100%;
  height: 70px;
  z-index: 9999;
  display: block;
  position: fixed;
  top: 0;
  &::after {
    content: "";
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    height: 0.5px;
    background-color: #dae1e7;
    width: 95%;
  }
}
</style>

